module.exports = __webpack_public_path__ + "static/fonts/MyriadPro-Bold.d5b4864.ttf";